import { AKA_FAMILY_ACCIDENT_PRICE_STEP } from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident";
import { AkaFamilyAccidentProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/ProductPrice/akaFamilyAccidentProductPriceInterfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export interface AkaFamilyAccidentProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;

  hasDeathCoverage: boolean;
  hasDisabilityCoverage: boolean;
  hasProfessionalDisabilityCoverage: boolean;

  dateOfBirth: string;
}

export const mapToCommerceAkaFamilyAccident = (
  data: Record<string, any>,
): AkaFamilyAccidentProductBackend => {
  const priceData: AkaFamilyAccidentProductPriceFormValues =
    data.formData[AKA_FAMILY_ACCIDENT_PRICE_STEP.id];
  const user = data.customerData.newCustomerResponse;

  return {
    name: INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT,
    coverageGroup: data.coverage,
    hasDeathCoverage: priceData.hasDeathCoverage,
    hasDisabilityCoverage: priceData.hasDisabilityCoverage,
    hasProfessionalDisabilityCoverage:
      priceData.hasProfessionalDisabilityCoverage,

    dateOfBirth: user.dateOfBirth,
  };
};
